/**
 * 接口统一管理
 */
import common from "./common.js"
import system from "./system.js"
import order from "./order.js"
import user from "./user.js"
import contents from "./contents.js"
import carouselPicture from "./carouselPicture.js"
import liveManage from "./liveManage.js"
import courseManage from "./courseManage.js"
import teacher from "./teacher.js"
import customerService from "./customerService.js"
import opinion from "./opinion.js"
import activityManage from "./activityManage.js"
import pointManage from "./pointManage.js"
import studyTour from "./studyTour.js"
import upload from "./upload.js"
import agreement from "./agreement.js"
import question from "./question.js"
import logs from "./logs.js"
import dynamic from "./dynamic.js"

const apiAll = [
  common,
  system,
  order,
  user,
  contents,
  carouselPicture,
  liveManage,
  courseManage,
  teacher,
  customerService,
  opinion,
  activityManage,
  pointManage,
  studyTour,
  upload,
  agreement,
  question,
  logs,
  dynamic,
  // ...
]

// 判断接口是否已存在
function isKeyQepeat(arr) {
  let keyArr = [],
    apiObj = {}
  arr.forEach(item => {
    keyArr.push(...Object.keys(item))
    Object.assign(apiObj, item)
  })
  try {
    keyArr.forEach((item, i, arr) => {
      if (arr.indexOf(item) !== i) {
        throw new Error(`接口 key 重复项: ${item}`)
      }
    })
  } catch (error) {
    console.error("[错误]:", error)
    return null
  }
  return apiObj
}
const apiDesc = isKeyQepeat(apiAll)
//进行统一导出
export default {
  ...apiDesc,
}
